import { Card, Flex, NumberInput, Text, Title } from '@tremor/react'
import type { InputsState, Labels } from '../types'

interface Props {
    inputs: InputsState
    setInputs: (updates: Partial<InputsState>) => void
    labels: Labels
}

export default function NetworkStep({ inputs, setInputs, labels }: Props) {
    return (
        <Card className="bg-teal-800 ring-teal-900">
            <Title className="text-lg mb-2 text-white">Networking</Title>
            <Flex
                justifyContent="between"
                alignItems="center"
                className="flex-col gap-2 md:flex-row md:gap-0"
            >
                <Text className="text-white w-full md:w-auto">
                    Data transfer out (GB/mo)
                </Text>
                <NumberInput
                    value={inputs.xferOutGb}
                    onValueChange={(v) => setInputs({ xferOutGb: v })}
                    min={0}
                    step={100}
                    className="w-full md:w-48"
                />
            </Flex>
            <Flex
                justifyContent="between"
                alignItems="center"
                className="flex-col gap-2 md:flex-row md:gap-0"
            >
                <Text className="text-white w-full md:w-auto">
                    Unused {labels.eipLabel}
                </Text>
                <NumberInput
                    value={inputs.unusedEips}
                    onValueChange={(v) => setInputs({ unusedEips: v })}
                    min={0}
                    step={1}
                    className="w-full md:w-48"
                />
            </Flex>
            <Flex
                justifyContent="between"
                alignItems="center"
                className="flex-col gap-2 md:flex-row md:gap-0"
            >
                <Text className="text-white w-full md:w-auto">
                    Idle {labels.lbLabel}
                </Text>
                <NumberInput
                    value={inputs.idleElbs}
                    onValueChange={(v) => setInputs({ idleElbs: v })}
                    min={0}
                    step={1}
                    className="w-full md:w-48"
                />
            </Flex>
        </Card>
    )
}
